<template>
  <div>
    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>
    <transition name="slide">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import DashboardHeader from "@/components/Shared/Header.vue";
import Menu from "@/components/Shared/Menu.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Dashboard",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE", "activeUser"])
  },
  methods: {
    ...mapActions(["TOGGLE_MENU", "SET_CONNECTCTED_CALENDARS"])
  },
  mounted() {
    const fcm_token = localStorage.getItem("fcm_token");
    this.$API
      .userSubscription(fcm_token)
      .then(res => res)
      .catch(err => {});
  },
  components: {
    DashboardHeader,
    Menu
  }
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
}
.slide-enter, .slide-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 1;
  transform: translateX(100%);
}
</style>
